import React from 'react';
import P from 'prop-types';

import colors from '../../../config/theme/colors';
const CircleTick = ({ size, fill }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18">
      <g fill="none">
        <path fill={fill} d="M9 0a9 9 0 1 0 9 9 9.026 9.026 0 0 0-9-9z" />
        <path fill="#FFF" d="M7.5 13.06L3.44 9 4.5 7.94l3 3 6-6L14.56 6z" />
      </g>{' '}
    </svg>
  );
};

CircleTick.propTypes = {
  size: P.number,
  fill: P.string,
};

CircleTick.defaultProps = {
  fill: colors.gulfstream,
};

export default CircleTick;
